const user_id = JSON.parse(localStorage.getItem("user_id"));
const ENV_PROD = true;
let URL;
let report_url;

if (ENV_PROD) {
  URL = "https://settlepaisaapi.sabpaisa.in/"; // SettlePaisa staging URL
} else {
  URL = "https://settlepaisainternalapi.sabpaisa.in/";
}

const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  baseUrl: URL,
  enableMock: false,
  user_id: user_id,
};

export default appConfig;
